























































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
    }
})
export default class ModalNotes extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop() noteTypes: Array<object>;
    noteDescription: string = '';
    typeSelected: any = null;
    typeRV: boolean = false;

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    saveNote() {
        this.showLoadingDialog('Guardando Nota...');
        InsuranceServices.postVehicleNote(this.getData)
            .then(res => {
                this.showSuccessLoadingDialog(res, 'Nota creada con éxito');
                this.$emit('add-new-note', res['new_note']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la nota');
            });
    }

    get getData() {
        return {
            vehicle_id: this.vehicleID,
            note_type: this.typeSelected['id'],
            text: this.noteDescription
        };
    }

    updateTypeSelected(value) {
        this.typeSelected = value;
    }
    updateTypeRV(value) {
        this.typeRV = value;
    }

    get formIsValid() {
        if (this.typeSelected !== null && this.noteDescription !== '') {
            return true;
        } else {
            return false;
        }
    }

    @Emit()
    closeModal() {}

    mounted() {}
}
